export const isTrue = (envParameter: string) => {
  const envValue = import.meta.env[envParameter];
  return envValue && /^true$|^1$/i.test(envValue);
};

export const isFalse = (envParameter: string) => !isTrue(envParameter);
